module.exports = __webpack_public_path__ + "static/media/objects_08.86315707.svg";